import React from 'react';

const CertificateList = ({ certificates }) => {
  if (!certificates || certificates.length === 0) {
    return (
      <div className="cert-list-wrapper">
        <h3>Видані сертифікати</h3>
        <p className="cert-list-empty">Поки що немає згенерованих сертифікатів у цій сесії.</p>
      </div>
    );
  }

  return (
    <div className="cert-list-wrapper">
      <h3>Видані сертифікати (ця сесія)</h3>
      <div className="cert-table-wrap">
        <table className="cert-table">
          <thead>
            <tr>
              <th>Номер</th>
              <th>Клієнт</th>
              <th>Тип</th>
              <th>Значення</th>
              <th>Видано</th>
              <th>Дійсний до</th>
            </tr>
          </thead>
          <tbody>
            {certificates.map((cert, idx) => (
              <tr key={idx}>
                <td><strong>{cert.number}</strong></td>
                <td>{cert.clientName}</td>
                <td>{cert.type === 'amount' ? 'Сума' : 'Процедура'}</td>
                <td>{cert.type === 'amount' ? cert.value + ' грн' : cert.value}</td>
                <td>{cert.issueDate}</td>
                <td>{cert.expiryDate}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CertificateList;
